import {
  NAV_SUCCESS,
  CHANGE_ROUTE,
  TOGGLE_MENU,
  SORT_NAV,
  HIGHLIGHT_NAVBAR_SECTION
} from './action-types'

export const navSuccess = payload => ({
  type: NAV_SUCCESS,
  payload
})

export const changeRoute = (payload, meta) => ({
  type: CHANGE_ROUTE,
  payload,
  meta
})

export const toggleMenu = payload => ({
  type: TOGGLE_MENU,
  payload
})

export const sortNav = (payload, meta) => ({
  type: SORT_NAV,
  payload,
  meta
})
export const highlightNavbarSection = (payload, meta) => ({
  type: HIGHLIGHT_NAVBAR_SECTION,
  payload,
  meta
})
